module.exports = "https://cdn.redage.net/src/views/player/help/images/azart4.jpg";